module.exports = __webpack_public_path__ + "img/DSC_4361.3e5e5b13.jpg";